import {
  getAnalytics,
  Analytics,
  setUserId,
  setUserProperties,
} from "firebase/analytics";
import { User } from "firebase/auth";
import { app } from "./app";

const getAnalyticsInstance = (): Analytics | null => {
  if (import.meta.env.VITE_ENVIRONMENT === "production") {
    return getAnalytics(app);
  }
  return null;
};

export const analytics = getAnalyticsInstance();

export const extractDomainFromEmail = (email: string): string => {
  const parts = email.split("@");
  return parts.length > 1 ? parts[parts.length - 1] : "";
};

export const setAnalyticsUserId = (userId: string): void => {
  try {
    setUserId(analytics!, userId);
  } catch (error) {
    console.error("Failed to set analytics user ID:", error);
  }
};

export const setAnalyticsDomain = (email: string): void => {
  try {
    const domain = extractDomainFromEmail(email);

    if (!domain) {
      console.error("Failed to extract domain from email:", email);
    }

    if (domain) {
      setUserProperties(analytics!, { domain });
    }
  } catch (error) {
    console.error("Failed to set analytics domain property:", error);
  }
};

export const setUserAnalyticsProperties = (user: User): void => {
  if (!analytics) {
    console.warn(
      "Analytics not initialized - user properties will not be tracked",
    );
    return;
  }

  setAnalyticsUserId(user.uid);
  setAnalyticsDomain(user.email || "");
};
